module.exports = __webpack_public_path__ + "static/media/whiteBackArrow.a4ef3f2c.svg";